import rootService from 'core/services.root';

export default rootService({
    deleteAgenda: ['DELETE', '/agenda/delete/:id'],
    deleteAppointment: ['PUT', '/appointment/cancel/:id'],
    deleteAppointmentType: ['DELETE', '/appointment/type/delete/:id'],
    deleteAvailableTime: ['DELETE', '/agenda/available/delete/:id'],
    deleteUnavailableTime: ['DELETE', '/agenda/unavailable/delete/:id'],
    fetchAppointment: ['GET', '/appointment/:id'],
    fetchAppointmentAudit: ['GET', '/audit/list'],
    getAgenda: ['GET', '/agenda/:id'],
    getAllAgendas: ['GET', '/agenda/listing?doctor_id=0'],
    getAllAppointments: ['GET', '/appointment/listing/all'],
    getAppointmentType: ['GET', '/appointment/type/:id'],
    getAppointmentTypes: ['GET', '/appointment/type/all'],
    getAvailableAgenda: ['GET', '/doctor/:doctor_id/attention'],
    getAvailableTimes: ['GET', '/agenda/doctor/available/listing'],
    getDoctorAgendas: ['GET', '/agenda/doctor/:doctor_id'],
    getDoctorAppointments: ['GET', '/appointment/doctor/listing/:doctor_id'],
    getSpecialtyAppointments: ['GET', '/appointment/specialty/listing/:specialty_id'],
    getUnavailableTimes: ['GET', '/agenda/doctor/unavailable/listing'],
    postAgenda: ['POST', '/agenda/store'],
    postAppointment: ['POST', '/appointment/store'],
    postAppointmentType: ['POST', '/appointment/type/store'],
    postAvailableTime: ['POST', '/agenda/available/store'],
    postExternalAppointment: ['POST', '/appointment/external-store'],
    postUnavailableTime: ['POST', '/agenda/unavailable/store'],
    putAgenda: ['PUT', '/agenda/update/:id'],
    putAppointment: ['PUT', '/appointment/update/:id'],
    putAppointmentType: ['PUT', '/appointment/type/update/:id']
});
